<template>

  <b-container fluid>
    <b-row>
      <b-col cols="12" xl="6">
        <h1 class="display-4">{{now|format_moment('dddd D MMMM')|capitalize}}</h1>
        <h2 class="mb-3">Lage tonerstand</h2>

        <b-tabs>
          <b-tab title="Tabel">

            <table-wrap :query="$options.query1" :fields="$options.fields1" small :per-page="10" class="mt-2">
              <template #cell(description)="row">
                {{row.item.model.brand.name}} {{row.item.model.name}}
                <span class="d-block d-lg-none">
                  <b-link :to="`/main/admin/printers/view/${row.item.id}`">{{row.item.serial}}</b-link>
                </span>
              </template>
              <template v-slot:cell(contracts)="{item: {contractPrinters: { nodes }}}">
                <template v-if="nodes.length === 0">
                  <span class="text-muted font-italic">Niet toegewezen aan een contract</span>
                </template>
                <template v-else>
                  <router-link :to="`/main/admin/contracts/view/${nodes[0].contract.id}`" class="mr-1">{{nodes[0].contract.name}}</router-link>
                  <br class="d-lg-none"><span class="text-muted">{{nodes[0].contract.customer.name}}</span>
                </template>
              </template>
              <template #cell(serial)="row">
                <b-link :to="`/main/admin/printers/view/${row.item.id}`">{{row.value}}</b-link>
              </template>
              <template #cell(ink)="{item: {c, m, y, k}}">
                <div class="ink-status text-nowrap">
                  <span v-if="c[0]" :class="{'blink-me': c[0].value < 35}"><span class="mdi mdi-water c" />{{c[0].value}}%</span><br class="d-lg-none">
                  <span v-if="m[0]" :class="{'blink-me': m[0].value < 35}"><span class="mdi mdi-water m" />{{m[0].value}}%</span><br class="d-xl2-none">
                  <span v-if="y[0]" :class="{'blink-me': y[0].value < 35}"><span class="mdi mdi-water y" />{{y[0].value}}%</span><br class="d-lg-none">
                  <span v-if="k[0]" :class="{'blink-me': k[0].value < 35}"><span class="mdi mdi-water k" />{{k[0].value}}%</span>
                </div>
              </template>
              <template v-slot:cell(location)="{item: {contractPrinters: { nodes }}}">
                <template v-if="nodes.length > 0">
                  {{nodes[0].location}}
                </template>
              </template>
            </table-wrap>

          </b-tab>
          <b-tab title="Kaart">
            <div class="mt-2">
              <GmapMap
                :center="{lat:50.8503, lng:4.3517}"
                :zoom="7"
                map-type-id="terrain"
                style="width: 100%; height: 450px"
              >
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="true"
                  :draggable="true"
                  @click="center=m.position"
                />
              </GmapMap>
            </div>
          </b-tab>
        </b-tabs>



      </b-col>

      <b-col cols="12" xl="6">
        <h1 class="display-4">{{now|format_moment('[Q]Q YYYY')}}</h1>

        <h2>Te factureren <br class="d-block d-md-none"><small class="text-muted">Afrekening van {{prev}} en eerder</small></h2>
        <table-wrap :query="$options.invoiceQuery" :fields="$options.invoiceFields" small hover :variables="toInvoiceVars" :per-page="15" class="text-nowrap">
          <template v-slot:cell(name)="row">
            <b-link :to="`/main/admin/contracts/view/${row.item.id}`">{{row.value}}</b-link>
          </template>
          <template v-slot:cell(actions)="{item}">
            <b-btn size="sm" variant="primary" :to="`/main/admin/contracts/createInvoice/${item.id}`"><span class="mdi mdi-rocket"/> Factuur maken</b-btn>
          </template>
          <template v-slot:cell(lastInvoice)="{item:{invoices:{nodes:[node]}}}">
            <template v-if="node">
              Q{{node.quarter}} {{node.year}} 
            </template>
            <span v-else class="font-italic">
              Geen
            </span>
          </template>
          <template v-slot:cell(too_late)="{item:{invoices:{nodes:[node]}}}">
            <span v-if="node">{{node|format_toolate(now)}} dagen</span>
          </template>
        </table-wrap>
      </b-col>
    </b-row>


  </b-container>

</template>

<script>
import moment from 'moment';

import TableWrap from '@/components/TableWrap';
import computedNow from '@/lib/computedNow';

export default
{
    components: {TableWrap},
    computed:
    {
        now: computedNow,
        toInvoiceVars()
        {
            const m = moment(this.$store.state.now);
            const p = moment(m).subtract(1, 'quarter');
            return {
                periodKey: (p.get('year') * 100000) + (p.get('quarter') * 1000)
            }
        },
        prev()
        {
            return moment(this.$store.state.now).subtract(1, 'quarter').format('[Q]Q YYYY');
        }
    },
    data()
    {
        return {
            markers: []
        }
    },
    query1: require('../../graphql/live/tasks_printer_toner_low.gql'),
    fields1:
    [
        {
            key: 'description',
            label: 'Beschrijving'
        },
        {
            key: 'serial',
            label: 'Serienummer',
            thClass: 'd-none d-lg-table-cell',
            tdClass: 'd-none d-lg-table-cell'
        },
        {
            key: 'ink',
            label: 'Inkt/Toner',
        },
        {
            key: 'contracts',
            /*search: String,
            searchPath: 'contract.contractId'*/
            label: 'Contract'
        },
        {
            key: 'location',
            label: 'Locatie'
        }
    ],
    invoiceQuery: require('../../graphql/live/to_invoice.gql'),
    invoiceFields:
    [
        {
            key: 'name',
            label: 'Contract'
        },
        {
            key: 'lastInvoice',
            label: 'Laatste'
        },
        {
            key: 'too_late',
            label: 'Te laat',
            tdClass: 'text-right',
            thClass: 'text-right'
        },
        {
            key: 'actions',
            label: 'Acties',
            thClass: 'text-right',
            tdClass: 'text-right'
        }
    ]
}
</script>

<style>
</style>